import { useQuery } from "@tanstack/react-query";
import { fetchCollectionsByBudget } from "@/api/campaignBuilder";

export function useCollectionsByBudget(budget: number | null) {
  return useQuery({
    queryKey: ["campaign-builder", "collections-by-budget", budget],
    queryFn: () => fetchCollectionsByBudget(budget!),
    // Unassigning a Custom Collection product must drop it from the grid now, not after the 5-min default.
    staleTime: 0,
    enabled: budget !== null,
  });
}
